import React, {useState} from "react"
import classnames from "classnames"
import FaIcon from "components/fa_icon"

const ImageGalleryCaption = ({
  images,
  show_image,
  current_image_index,
  previous_item,
  next_item
}) => {
  const current_image = images[current_image_index]
  const [show_content_pane, set_show_content_pane] = useState(false)
  return (
    <div className="gallery__caption">
      <div className="gallery__caption-container">
        <div className="gallery__caption-title">
          {typeof current_image.caption.title === "string"
            ? <div className="caption-title__primary">
                {current_image.caption.title}
              </div>
            : current_image.caption.title}
        </div>
        {images.length > 1 && (
          <>
            <div className="gallery-previous" onClick={previous_item}>
              <FaIcon name={"fa-angle-left"}/>
            </div>
            <div className="gallery-positioning-indicator">
              {current_image_index + 1}/{images.length}
            </div>
            <div className="gallery-next" onClick={next_item}>
              <FaIcon name={"fa-angle-right"}/>
            </div>
            <div
              onClick={() => set_show_content_pane(!show_content_pane)}
              className={classnames("gallery-content", {
                "gallery__control--active": show_content_pane
              })}>
                <FaIcon name={"fa-align-left"}/>
            </div>
          </>
        )}
      </div>
      {!show_content_pane &&
        <div className="gallery__caption-description">
          <DescriptionContent content={current_image.caption.description} />
        </div>}
      {show_content_pane &&
        <ContentPane
          images={images}
          show_image={show_image}
          current_image_index={current_image_index}
        />}
    </div>
  )
}

const DescriptionContent = ({content}) => {
  if (!content) return
  if (typeof content !== "string") return content

  return <div dangerouslySetInnerHTML={{__html: content}}></div>
}

const ContentPane = ({images, show_image, current_image_index}) => (
  <ul className="gallery__content-pane">
    {images.map((image, index) => {
      const title = image.title || image.caption.title
      return (
        <li key={index}>
          <a
            className={index === current_image_index ? "active" : ""}
            onClick={() => show_image(image)}
          >
            {/* image name is formatted as "primary name (secondary name)" */}
            {title}
          </a>
        </li>
      )
    })}
  </ul>
)

export default ImageGalleryCaption
